import { render, staticRenderFns } from "./ReactivationDemo.vue?vue&type=template&id=444b04d6&"
import script from "./ReactivationDemo.vue?vue&type=script&lang=js&"
export * from "./ReactivationDemo.vue?vue&type=script&lang=js&"
import style0 from "./ReactivationDemo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports